import styled from 'styled-components'
import Mobile from '../../components/Mobile'
import { media } from '../../theme'

const StyledMobile = styled(Mobile)`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;

  ${media.greaterThan('medium')`
    display: none;
  `};
`

export default StyledMobile



// WEBPACK FOOTER //
// ./src/pages/living-room/_StyledMobile.js